export default {
	NotifyPayment: 'Payment due reminders',
	OnNotify: 'Enable notifications',
	OffNotify: 'Mute notifications',
	Series: 'Serial',
	TemplateNo: 'Form No.',
	InvoiceNo: 'Invoice No.',
	TaxCode: 'Tax code',
	SellerTaxCode: 'Seller tax code',
	InvoiceDate: 'Invoice date',
	SettingDownload: 'Set the download file name',
	SettingConnectTax: 'Set up to connect tax authority ',
	ContentConnectTax: 'Download out invoice issued by MISA-MeInvoice',
	SettingUnDownloadSupplier: 'Set up to not download invoices arcording to suppliers',
	SupplierFilterOption1: 'Skip some suppliers when downloading invoices',
	SupplierFilterOption2: 'Only download invoices from selected suppliers',
	DownloadInvoiceWithoutCode:
		'Download the invoice without tax code sent in the form of Periodic declaration data summary to Tax Authority',
	DownloadOutInvoiceWithoutCode:
		'Download the invoice without tax code sent in the form of Periodic declaration data summary to Tax Authority',
	AutoMoveInvoice: 'Automatically transfer invoices to branches/departments',
	Setting: 'Setting',
	Edit: 'Edit',
	Delete: 'Delete',
	EmailReceiveInvoice: 'Invoice receiving email',
	OrgName: 'Unit name',
	SupplierNumber: 'Quantity of suppliers',
	AddNew: 'Add new',
	SuppliersNoDownloadInvoice: 'List of suppliers not download invoices',
	Taxaxion: {
		ConfigTransferInvoie: 'Set up to transfer invoices',
		ConfigTransfer: 'Add transfer settings',
		EditTransferInvoice: 'Edit transfer settings',
		TakeEmailFromSupplier: 'Receive invoices from suppliers',
		NotFindSupplier: 'No seller found',
		AddConfigSuccess: 'Set up to transfer invoices successfully',
		EditConfigSuccess: 'Edit to set up to transfer invoices successfully',
		AlertExistConfig: {
			FirstText: 'There already exists an automatic invoice transfer setting of email',
			SecondText: 'on the list'
		},
		AlertExistConfigSupplier: 'There is a supplier that has been automatically assigned to another ',
		AccountExistConfig: 'Account set up',
		CannotConfig: 'Can not set-up',
		ListAutoTransfer: 'List of automatic invoice transfers for branches/departments',
		AlertDeleteBranch: {
			Title: 'Do you want to delete the branch/department?',
			FirstText: 'There already exists an automatic invoice transfer setting of email',
			Detail: 'Data after deletion cannot be recovered.',
			SecondText: 'from the list of automatic invoice transfers'
		},
		DeleteConfigSuccess: 'Deleted to set-up a  invoice transfer successfully',
		SupplierInfo: 'Supplier information',
		SupplierExistOnSystem: (identity, name) =>
			`The supplier <${identity} - ${name}> already exists on the system. Please select from the list.`,
		SupplierExist: 'Supplier name already exists'
	},
	FillTaxCodeToFind: "Enter your tax code/identification number or supplier's name to search",
	SupplierName: 'Supplier name',
	Address: 'Address',
	NeedDeleteSupplierToAdd:
		'You need to remove the provider on the invoice transfer list of the email &lt;info@meinvoice.vn&gt; to add new supplier into new email',
	UnitCode: 'Unit code',
	UnitName: 'Unit name',
	SupplierAddress: 'Address',
	AddSupplierNoDownload: "Add a new supplier that doesn't download invoices",
	SupplierInfo: 'Supplier information',
	NeedSelectOneSupplier: 'You must select at least one supplier',
	NotInfoAboutIndetifyCodes: 'No information about tax code or identification number. Please check again.',
	NotInfoAboutIndetifyCodes1: 'No information about tax code on the Tax Authority website. Please check again.',
	SupplierExist: 'Supplier name already exists',
	AddSupplierNoDownloadSuccess: "Add set-up supplier that doesn't download invoices successfully",
	AddSupplierNoDownloadFail: "Add set-up supplier that doesn't download invoices fail",
	AddSupplierOnlyDownloadSuccess: 'Add supplier download invoices setting successfully',
	AddSupplierOnlyDownloadFail: 'Add supplier download invoices setting failed',
	SupplierWasTransfer: 'The supplier has set up automatic transfers to the department',
	System: {
		NumberDateNotify: 'Reminder date of early due',
		NotifyBefore: 'Reminder early due',
		FileNameDownLoad: 'The download file name includes:',
		InfoOnFileName: 'Information on file name',
		TooltipFileName: maxLength =>
			`The program will automatically shorten the download file name if the length is greater than ${maxLength} characters`,
		Example: 'For example:',
		OutInvoice: 'Output invoice',
		InbotInvoie: 'Input invoice',
		SelectSupplier: 'Establish',
		SupplierWasSelected: 'Selected supplier ',
		Change: 'Change',
		SelectBranchOrDepartment: 'Select branch/department',
		BuyerTaxCodeSelected: 'Tax code/Identification number have been selected',
		WarningFileNameLength:
			'If your file name is too long, the system will automatically remove the last characters to ensure the download file name is limited to 100 characters.'
	},
	BuyerName: 'Buyer name',
	BuyerTaxCodeSettingDownload: 'Buyer tax code',
	InvoiceNote: 'Note',
	SellerName: 'Seller name',
	ListSupplierNoDownload: 'List of suppliers not download invoices',
	ConfirmDeleteSupplierNoDownload:
		"Are you sure you want to remove the supplier from the list of suppliers that doesn't download invoices?",
	TitleDeleteSupplierNoDown: 'Do you want to remove the supplier?',
	DeleteConfigSupplierNoDownloadSuccess: 'Deleted successfully',
	DeleteConfigSupplierNoDownloadFail: "Delete to set-up suppliers that doesn't download invoices failure",
	DeleteSettingTransferInvSuccess: 'Deleted to set-up to transfer invoices in inbox successfully',
	DeleteSettingTransferInvFail: 'Delete to set-up to transfer invoices in inbox failure',
	DeleteSettingTransferInv: 'Delete the bill transfer setting at a successful mailbox',
	SettingTransferInvoice: 'Set up to transfer invoice from email source',
	TransferInvByTaxCode: 'Automatic transfer by buyer tax code/identification number',
	SettingWarningData: 'Set up incorrect invoice alerts about calculation figures',
	SettingCheckingInvoice: 'Set up invoice check',
	SettingSupplier: 'Set up supplier',
	SettingTemplate: 'Set default invoice template',
	TitleSettingTemplate: 'Set up invoice templates',
	BackgroundImage: 'Background image',
	Borders: 'Borders',
	FontSize: 'Font size',
	Normal: 'Normal',
	Small: 'Small',
	TooltipFontSize: 'Settings for VAT invoice template on Web version',
	ProductService: 'Products and Services',
	TooltipProductService: 'Settings for VAT invoice template on Web version',
	No: 'No.',
	Nature: 'Nature',
	ItemCode: 'Item code',
	TooltipItemCode:
		'When selected, the Item code column will automatically be displayed on the default template if the invoice XML contains item code information',
	SettingBackgroundImageTooltip: 'Set up invoice template on Web version',
	SettingBorderTooltip: 'Set up invoice template on Web and Mobile versions',
	HideSpecificProductInfo: 'Hide specific product information',
	HiddenVatRate: 'Hidden tax rates do not arise',
	HiddenTotalFee: 'Hide total fees when not incurred',
	HiddenDiscountAmount: 'Hide the total amount of trade discounts when they do not arise',
	IsStatusInvoiceCancel: 'Display status for canceled, replaced, and adjusted invoices',
	StatusInvoiceTitle: 'Invoice status',
	WarningOnList: 'Warning calculation of data on the list is not accurate',
	EmailReceiveAlert: 'Alert via email when a customer/supplier changes their operating status',
	ListTransferByTaxCode: 'List of automatic invoice transfer from mail source',
	BuyerTaxCode: 'Buyer tax code/Identification number on invoice',
	TaxaxionTaxCode: {
		BuyerTaxCodeInv: 'Buyer tax code/Identification number on invoice',
		PlaceHoderBuyerTaxCodeInv: 'Enter buyer tax code/Identification number on invoice to search',
		SettingTransfer: 'Set up to transfer',
		AddTransfer: 'Add transfer settings',
		EditTransfer: 'Edit transfer settings',
		ValidOrg: 'the branch/department to transfer to.',
		NoExitstOrg: 'Tax code/Identification number does not exist on the list.<br>Please check again.',
		ValidIndetityCode: 'Please enter tax code or citizen identity card.<br>Please check again.',
		OrganizationMove: 'Branch department moved to',
		taxCodeText: taxCode => `Tax code &lt;${taxCode}&gt;`,
		identificationNumberText: identificationNumber => `Identification number &lt;${identificationNumber}&gt;`,
		ContainEmailTranfer: (identityCode, email) =>
			`There is already an invoice transfer setting with ${identityCode} to email &lt;${email}&gt;. Please check again.`,
		TaxCode: 'Tax code',
		IdentificationNumber: 'Identification number'
	},
	ConfirmDeleteTransferInv: 'Data cannot be recovered after deletion.',
	TitleConfirmDeleteTransferInv: 'Do you want to delete this transfer setting',
	AddSettingTransferInvSuccess: 'Add to set-up to transfer invoices in inbox successfully',
	AddSettingTransferInvFail: 'Add to set-up to transfer invoices in inbox failure',
	EditSettingTransferInvSuccess: 'Edit to set-up to transfer invoices in inbox successfully',
	EditSettingTransferInvFail: 'Edit to set-up to transfer invoices in inbox failure',
	ContainSettingTaxCode: 'Already exists setting up a tax code on the list',
	AlreadySettingTransferInv: (identityCode, orgName, email) =>
		`${identityCode} has been set up to transfer to branch/department &lt;${orgName}&gt; - email &lt;${email}&gt;. Do you want to replace the setting?`,
	NotAuthorFeature: 'You are not authorized to perform this feature',
	SelectOtherDownloadInvoice: 'Choose another type of download invoice',
	SelectDownloadInvoice: 'Select the type of invoice to download',
	ShowInvoiceLoadingList: 'Set up display of invoices loading (synchronizing) from the tax authority',
	ShowInvoiceLoading: 'Display',
	HideInvoiceLoading: 'Do not display',
	ShowInvoiceLoadingListTooltip:
		'This setting will display the list of “downloading invoices” (being synchronized) from the tax authority in the input invoice module.',
	ShowOutInvoiceLoadingList: 'Set up display of invoices loading (synchronizing) from the tax authority',
	ShowOutInvoiceLoadingListTooltip:
		'This setting displays outgoing invoices downloading from the tax authority in the output invoice module.',
	ConfirmUnPaymentInvoice:
		'The program will delete the entire payment history of the invoice. The data cannot be recovered.',
	ConfirmUnPaymentInvoiceTitle: 'You want to delete the payment history',
	UnPaymentInvoiceSuccess: 'Unmark bill payment successful',
	UnPaymentInvoiceFail: 'Unmark failed bill payment',
	IgnoreCheckExistTax: 'The list of invoice numbers, serial not accepted exists on the Tax Authority',
	TooltipIgnoreCheckExistTax:
		'Declare the invoice number, serial not accepted by reputable suppliers if you do not want the program to check and warn invoices that do not exist on the Tax Authority.',
	ListIgnoreCheckExistTax: 'The list of invoice numbers, serial not accepted exists on the Tax Authority',
	StartDate: 'Start date',
	EndDate: 'End date',
	SearchPlaceHolder: 'Enter your name, tax code/identifycation number, serial to search',
	SupplierAccept: {
		SupplierInfo: `Add supplier's form number and serial`,
		WarningValidateDuplicate: (series, taxCode, name) =>
			`Supplier serial <${series}> <${taxCode} - ${name}> already exist.`,
		TitleDuplicate: 'Survive supplier',
		InsertSuccess: 'Successfully added new',
		InsertFail: 'Failure add new',
		UpdateSuccess: 'Successfully update',
		UpdateFail: 'Failure update',
		DeleteSuccess: 'Deleted successfully',
		DeleteFail: 'Failure delete',
		TitleConfirmDelete: 'You want to delete the form number and serial',
		ContentConfirmDelete: 'The data cannot be recovered after deletion.'
	},
	ListEmailAlert: 'List of emails to receive alerts',
	EmailAlert: 'Email to receive notifications',
	EmailReceiveAlertInfo: {
		AddEmail: 'Add email new',
		InsertSuccess: 'Successfully added new',
		InsertFail: 'Failure add new',
		UpdateSuccess: 'Successfully update',
		UpdateFail: 'Failure update',
		ConfirmDelete: email => `Are you sure you want to remove this &lt;${email}&gt;?`,
		DeleteSuccess: 'Deleted successfully',
		DeleteFail: 'Failure delete',
		TitleDuplicate: 'Duplicates the declared email',
		WarningValidateDuplicate: (series, taxCode, name) => `Email &lt;${series}&gt; already exist.`,
		DeleteConfirmTitle: 'Do you want to delete the alert email?',
		DeleteConfirmBody: 'Deleted data cannot be recovered.'
	},
	NeedDisplayInvoiceNo: 'You need to set up invoice number display',
	SaveSettingSuccess: 'Setuped successful',
	SaveSettingFail: 'Setup fail',
	SettingRemind: 'Setting Remind',
	SetupTheCriteriaToBeTested: 'Set up the criteria to be tested',
	SettingCriteria: 'Set up check criteria on invoices',
	TooltipSettingCriteria: 'Set up the criteria that users want the program to check on the invoice.',
	ShowNotificationNew: 'Always display when there are new notifications',
	TemplateDetail: {
		Date: '03 June 2025',
		TaxAuthorityCode: 'Tax Authority code : M1-25-OVEN3-00400038881'
	},
	CostType: 'Cost type',
	Date: 'Time',
	NormsAccordingToInvoice: 'Norms according to invoice (VND)',
	NormsAccordingToTime: 'Norms according to time (VND)',
	SettingClassificationInvoice: 'Set up invoice classification and cost norms',
	CostNorms: 'Cost norms',
	Setting: 'Establish',
	CostNormsDesc: 'Set up norms according to invoices (VND).',
	SeeFeatureIntroduction: 'See feature introduction',
	AutoClassification: 'Automatically classify',
	AutoClassificationNoted:
		'"Invoices entered into the software will be automatically classified according to the available cost list."',
	CostTypeList: 'List of cost types',
	CostNormListTitle: 'Set up cost norms according to invoice',
	NoteCostType:
		'Currently, the software automatically recognizes these types of costs. The list of cost types is continuously being updated.',
	SettingStatusInvoiceCancel: 'Cancelled',
	CostNormsByInvoice: 'Cost norms by invoice',
	CostNormsByInvoiceTooltip:
		'Set norms for each invoice (VND). Check the norms results in the invoice list and reports.',
	CostNormsByTime: 'Cost norms by time',
	CostNormsByTimeTooltip: 'Set cost norms by month/quarter/year (VND). Check the norms results in the reports.',
	CostNormListTitleByTime: 'Set cost norms by time',
	CriteriaSetupForm: {
		Title: 'Set up check criteria on invoices',
		ListCriteria: 'List of criteria',
		CheckedCriteria: 'Check criteria',
		ConclusionOfInvalidInvoice: 'Conclusion of invalid invoice',
		TooltipConclusionOfInvalidInvoice:
			'The choice of criteria will influence whether the invoice is "valid" or "not" valid.',
		TooltipCheckedCriteria: 'Any criteria not selected will not be checked on the invoice.',
		ShowOnList: 'Show on list',
		TooltipDisplayInList: 'Display check results on the invoice list',
		ConfirmSave:
			'Change only applies to invoices checked after setup. For old invoices, please press Check again if you want to update the check result according to this setup.',
		SaveError: 'Save criteria check setup failed'
	},
	TaxCodeAndIdentification: 'Tax Code/Identification Number',
	IdentificationNumber: 'Household Head ID',
	RequiredTaxCodeOrIdentification:
		'Required to enter 1 of 2 information "Personal identification number" or "Tax code"',
	AmountBeforeDiscountSettings: 'Configure the calculation formula for the Amount before discount value',
	AmountBeforeDiscountSettingsTooltip:
		'Configure the formula for calculating the Amount before discount for input/output invoices.',
	AmountBeforeDiscountSetup: {
		Title: 'Set up formula for calculating amount before discount',
		Subtitle: 'Formula for calculating amount before discount:',
		Formula1Condition: num =>
			`Case |(Quantity × UnitPrice) - Amount| ≤ Amount <span style="color: #00A2CF;">±${num}</span> unit(s)`,
		Formula1Condition1: '→ Amount before discount = Amount',
		Formula1Condition2: '(Difference value)',
		Formula1Result: 'Amount',
		Formula2Condition: 'Otherwise',
		Formula2Result: '→ Amount before discount = Amount + Discount',
		DeviationLabel: 'Adjust deviation value',
		DeviationRangeWarning: 'Deviation value can be adjusted in the range from 1 to 10',
		ColSoLuong: 'Quantity',
		ColDonGia: 'Unit Price',
		ColThanhTien: 'Amount before discount',
		ColChietKhau: 'Discount',
		ColThueSuat: 'Tax rate',
		Example: 'Example',
		FooterNote: 'Data is taken from the XML file of the invoice'
	},
	AbbreviationSettings: 'Abbreviation check settings for buyer/seller name and address',
	AbbreviationSetup: {
		Title: 'Abbreviation check settings for buyer/seller name and address',
		Warning: 'The program does not distinguish between uppercase and lowercase letters when checking.',
		Warning1:
			'The check result currently accepts correct abbreviations. If you check "<span style="font-weight: 700;color: #212529">Warning</span>", the program will <span style="font-weight: 700;color: #F5222D">give incorrect warnings</span> when the seller\'s name/address on the invoice <span style="font-weight: 700;color: #212529">differs</span> from the <span style="font-weight: 700;color: #212529">tax authority</span>, or the buyer\'s name/address <span style="font-weight: 700;color: #212529">differs</span> from the <span style="font-weight: 700;color: #212529">organizational structure</span>.',
		WordList: 'Word list',
		Abbreviation: 'Abbreviation',
		Check: 'Warning',
		NameOnTax: 'Name on tax authority',
		AddressOnTax: 'Address on tax authority',
		NameOnInvoice: 'Name on invoice',
		AddressOnInvoice: 'Address on invoice',
		True: 'True',
		False: 'False',
		CheckExplanation: 'Check explanation',
		FooterNote: 'This setting is not included in Decree 70 regulations',
		Cancel: 'Cancel',
		Save: 'Save',
		CheckProvince: 'Check for the word "Tỉnh" in the address',
		TooltipCheckProvince:
			'When checked, the program will warn if the address on the invoice and on the system differs by the word "Tỉnh" (Example: "Tỉnh Hà Nam" and "Hà Nam").'
	},
	SupplierOnlyDownload: {
		TitleFormAddSupplier: 'Add new supplier to download invoices',
		AddSupplierOnlyDownload: 'Add new supplier to download invoices',
		TitleSupplierOnlyDownload: 'List of suppliers to download invoices',
		ConfirmDeleteLastSupplierOnlyDownload:
			'<div>The <strong>Download invoices by supplier</strong> feature requires at least one supplier in the list. If you delete the last supplier, the program will switch to default mode to download all invoices from the Tax Authority.<br/>Are you sure you want to delete?</div>',
		ConfirmDeleteSupplierOnlyDownload: 'Are you sure you want to remove the supplier from the list?',
		TitleConfirmBeforeSaveSetting: 'You have not selected any supplier to download invoices',
		Default: 'Switch to default',
		Continue: 'Continue to declare',
		ConfirmBeforeSaveSetting:
			'Please declare at least one supplier or the program will switch to default mode to download all invoices from the Tax Authority. Do you want to continue declaring suppliers?'
	},
	NoDataSearchSupplierAccept: 'No suppliers found matching the search criteria, please try again',
	EmptyDataSearchSupplierAccept: `There are no suppliers`
};
